import React from 'react';
import Cookies from 'js-cookie';
import {
  Breadcrumb, Card, Row, Col, Form, Input, Button,
  message, Modal, Table, Tag, Typography, Space, Tooltip, DatePicker, Tabs, Select, Alert,
  Pagination, Checkbox,
} from 'antd';
import {
  CarOutlined, EditOutlined, SearchOutlined, ReloadOutlined,
  CheckCircleOutlined, FileTextOutlined, HistoryOutlined,
  WarningOutlined, ExclamationCircleOutlined, SwapOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';
import moment from 'moment';
import ErrorAlertModal from '../../components/ErrorAlertModal';
import SuccessAlertModal from '../../components/SuccessAlertModal';
import { toastError } from '../../utils/toast';

const { Text } = Typography;
const { TabPane } = Tabs;
const config = new Config();

const configClass = {
  title: 'Koreksi Nomor Notice',
  apiUrl: {
    data: 'transaksi/api/koreksi-notice/',
  },
  breadCrumb: [<span><CarOutlined /> Transaksi</span>, 'Koreksi Nomor Notice'],
};

const STATUS_COLOR = { 1: 'default', 2: 'blue', 3: 'green' };
const STATUS_LABEL = { 1: 'Pendaftaran', 2: 'Penetapan', 3: 'Pembayaran' };


class DataKoreksiNomorNotice extends React.Component {
  formRef = React.createRef();
  formMassalRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'transaksi',
      // superadmin filter
      kabupatenList: [],
      uptList: [],
      selectedKabupaten: null,
      selectedUpt: null,
      loadingKabupaten: false,
      loadingUpt: false,
      // tab transaksi
      loadingData: false,
      dataSource: [],
      ringkasanLoncatan: null,
      pagination: { current: 1, pageSize: 25, total: 0 },
      searchText: '',
      tanggal: moment(),
      // tab riwayat
      loadingRiwayat: false,
      riwayatSource: [],
      riwayatPagination: { current: 1, pageSize: 25, total: 0 },
      // modal edit
      isModalEdit: false,
      loadingSave: false,
      editRecord: null,
      loadingBatas: false,
      batasNotice: null,
      // koreksi massal (renumber rentang)
      isModalMassal: false,
      loadingMassalPreview: false,
      massalPreview: null,
      massalValues: null,
      loadingMassalSubmit: false,
      // error
      errTitle: '',
      errMsg: '',
      // success/warning modal
      successVisible: false,
      successType: 'success',
      successTitle: '',
      successContent: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.initHandler();
  }

  async componentDidMount() {
    await this.props.initHandler();
    this.fetchKabupaten();
    this.initKabupatenFromCookie();
    this.getData();
  }

  // Kabupaten yang dipilih pegawai saat login (cookie _upt) - dipakai untuk
  // auto-isi + kunci form Kabupaten pada non-superadmin, sama seperti
  // LapPenggunaanNoticeRusak.jsx.
  initKabupatenFromCookie = async () => {
    if (this.props.is_superuser) return;
    let kabupatenId;
    try {
      const rawCookie = Cookies.get(config.get_cookie_name() + '_upt');
      if (!rawCookie) return;
      const parsed = JSON.parse(decodeURIComponent(rawCookie));
      kabupatenId = parsed.kabupaten;
      if (!kabupatenId) return;
    } catch (err) {
      console.warn('Cookie _upt tidak valid:', err);
      return;
    }
    this.setState({ selectedKabupaten: kabupatenId, loadingUpt: true });
    try {
      await this.props.ajaxViewHandler('get', `pegawai/api/upt/?kabupaten=${kabupatenId}&limit=200`);
      if (this.props.isSuccess) {
        this.setState({ uptList: this.props.responseMsg.results || [] });
      }
    } catch {
      // ignore
    } finally {
      this.setState({ loadingUpt: false });
    }
  };

  isKabupatenLocked() {
    if (this.props.is_superuser) return false;
    try {
      const rawCookie = Cookies.get(config.get_cookie_name() + '_upt');
      if (!rawCookie) return false;
      const parsed = JSON.parse(decodeURIComponent(rawCookie));
      return Boolean(parsed.kabupaten && parsed.id);
    } catch (err) {
      return false;
    }
  }

  _buildUptParams() {
    if (!this.props.is_superuser) return '';
    const { selectedUpt, selectedKabupaten } = this.state;
    if (selectedUpt) return `&upt=${selectedUpt}`;
    if (selectedKabupaten) return `&kabupaten=${selectedKabupaten}`;
    return '';
  }

  fetchKabupaten = async () => {
    this.setState({ loadingKabupaten: true });
    try {
      await this.props.ajaxViewHandler('get', 'master/api/kabupaten/?limit=200');
      if (this.props.isSuccess) {
        this.setState({ kabupatenList: this.props.responseMsg.results || [] });
      }
    } catch {
      // ignore
    } finally {
      this.setState({ loadingKabupaten: false });
    }
  };

  handleKabupatenChange = async (val) => {
    this.setState({ selectedKabupaten: val, selectedUpt: null, uptList: [], loadingUpt: true });
    try {
      await this.props.ajaxViewHandler('get', `pegawai/api/upt/?kabupaten=${val}&limit=200`);
      if (this.props.isSuccess) {
        this.setState({ uptList: this.props.responseMsg.results || [] });
      }
    } catch {
      // ignore
    } finally {
      this.setState({ loadingUpt: false });
    }
    this.setState({
      pagination: { ...this.state.pagination, current: 1 },
      riwayatPagination: { ...this.state.riwayatPagination, current: 1 },
    }, () => {
      this.getData(this.state.pagination.pageSize, 0);
      this.getRiwayat(this.state.riwayatPagination.pageSize, 0);
    });
  };

  handleUptChange = (val) => {
    this.setState({
      selectedUpt: val,
      pagination: { ...this.state.pagination, current: 1 },
      riwayatPagination: { ...this.state.riwayatPagination, current: 1 },
    }, () => {
      this.getData(this.state.pagination.pageSize, 0);
      this.getRiwayat(this.state.riwayatPagination.pageSize, 0);
    });
  };

  async getData(
    limit = this.state.pagination.pageSize,
    offset = 0,
    search = this.state.searchText,
    tanggal = this.state.tanggal,
  ) {
    this.setState({ loadingData: true });
    const tanggalStr = tanggal ? tanggal.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    try {
      const url = `${configClass.apiUrl.data}?limit=${limit}&offset=${offset}&search=${search}&tanggal=${tanggalStr}${this._buildUptParams()}`;
      await this.props.ajaxViewHandler('get', url);
      if (this.props.isSuccess) {
        const data = this.props.responseMsg;
        const results = data.results || [];
        // deteksi duplikat dalam halaman ini
        this.setState({
          dataSource: results,
          ringkasanLoncatan: data.ringkasan_loncatan || null,
          pagination: { ...this.state.pagination, total: data.count },
        });
      } else {
        message.error({ content: 'Gagal memuat data.', duration: 2, key: 'toast' });
      }
    } catch {
      message.error({ content: 'Terjadi kesalahan saat memuat data.', duration: 2, key: 'toast' });
    } finally {
      this.setState({ loadingData: false });
    }
  }

  async getRiwayat(
    limit = this.state.riwayatPagination.pageSize,
    offset = 0,
    tanggal = this.state.tanggal,
  ) {
    this.setState({ loadingRiwayat: true });
    const tanggalStr = tanggal ? tanggal.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
    try {
      const url = `${configClass.apiUrl.data}riwayat/?limit=${limit}&offset=${offset}&tanggal=${tanggalStr}${this._buildUptParams()}`;
      await this.props.ajaxViewHandler('get', url);
      if (this.props.isSuccess) {
        const data = this.props.responseMsg;
        this.setState({
          riwayatSource: data.results || [],
          riwayatPagination: { ...this.state.riwayatPagination, total: data.count },
        });
      } else {
        message.error({ content: 'Gagal memuat riwayat.', duration: 2, key: 'toast' });
      }
    } catch {
      message.error({ content: 'Terjadi kesalahan saat memuat riwayat.', duration: 2, key: 'toast' });
    } finally {
      this.setState({ loadingRiwayat: false });
    }
  }

  handleTableChange = (pagination) => {
    const offset = pagination.current === 1 ? 0 : (pagination.current - 1) * pagination.pageSize;
    this.setState({ pagination }, () => this.getData(pagination.pageSize, offset));
  };

  // Adapter - <Pagination> berdiri sendiri (pagination bawaan <Table> dimatikan,
  // lihat _buildTableRows) memanggil onChange dgn (page, pageSize) terpisah,
  // beda bentuk dari objek pagination lengkap yang dikirim <Table onChange>.
  handlePaginationChange = (page, pageSize) => {
    this.handleTableChange({ ...this.state.pagination, current: page, pageSize });
  };

  handleRiwayatTableChange = (pagination) => {
    const offset = pagination.current === 1 ? 0 : (pagination.current - 1) * pagination.pageSize;
    this.setState({ riwayatPagination: pagination }, () => this.getRiwayat(pagination.pageSize, offset));
  };

  handleSearch = () => {
    this.setState(
      { pagination: { ...this.state.pagination, current: 1 } },
      () => this.getData(this.state.pagination.pageSize, 0, this.state.searchText, this.state.tanggal),
    );
  };

  handleTanggalChange = (val) => {
    this.setState(
      {
        tanggal: val,
        pagination: { ...this.state.pagination, current: 1 },
        riwayatPagination: { ...this.state.riwayatPagination, current: 1 },
      },
      () => {
        this.getData(this.state.pagination.pageSize, 0, this.state.searchText, val);
        this.getRiwayat(this.state.riwayatPagination.pageSize, 0, val);
      },
    );
  };

  handleKodeNoticeBlur = async (e) => {
    const kode = e.target.value.trim();
    if (!kode) return;
    this.setState({ loadingBatas: true, batasNotice: null });
    try {
      const blurParams = new URLSearchParams({ kode_notice: kode });
      if (this.props.is_superuser && this.state.editRecord?.upt) blurParams.set('upt', this.state.editRecord.upt);
      await this.props.ajaxViewHandler('get', `${configClass.apiUrl.data}batas-notice/?${blurParams.toString()}`);
      if (this.props.isSuccess) {
        this.setState({ batasNotice: this.props.responseMsg });
      }
    } catch {
      // batas tidak tersedia
    } finally {
      this.setState({ loadingBatas: false });
    }
  };

  handleTabChange = (key) => {
    this.setState({ activeTab: key }, () => {
      if (key === 'riwayat' && this.state.riwayatSource.length === 0) {
        this.getRiwayat();
      }
    });
  };

  openEdit = async (record) => {
    this.setState({ isModalEdit: true, editRecord: record, loadingBatas: true, batasNotice: null });
    try {
      const batasParams = new URLSearchParams();
      if (record.kode_notice) batasParams.set('kode_notice', record.kode_notice);
      if (this.props.is_superuser && record.upt) batasParams.set('upt', record.upt);
      const batasQuery = batasParams.toString();
      await this.props.ajaxViewHandler('get', `${configClass.apiUrl.data}batas-notice/${batasQuery ? '?' + batasQuery : ''}`);
      if (this.props.isSuccess) {
        this.setState({ batasNotice: this.props.responseMsg });
      }
    } catch {
      // batas tidak tersedia, validasi tetap dilakukan di backend
    } finally {
      this.setState({ loadingBatas: false });
    }
  };

  handleSave = async () => {
    let values;
    try {
      values = await this.formRef.current.validateFields();
    } catch {
      return;
    }
    const { editRecord } = this.state;
    this.setState({ loadingSave: true });
    this.props.ajaxHandler(
      'patch',
      `${configClass.apiUrl.data}${editRecord.id}/?tanggal=${this.state.tanggal ? this.state.tanggal.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}`,
      { notice_number: parseInt(values.notice_number, 10), kode_notice: values.kode_notice },
      false,
      true,
    ).then(() => {
      this.setState({ loadingSave: false });
      if (this.props.isSuccess) {
        const resp = this.props.responseMsg;
        this.setState({ isModalEdit: false, editRecord: null });
        this.getData(
          this.state.pagination.pageSize,
          (this.state.pagination.current - 1) * this.state.pagination.pageSize,
        );
        // refresh riwayat juga agar data terbaru langsung muncul
        this.getRiwayat(
          this.state.riwayatPagination.pageSize,
          (this.state.riwayatPagination.current - 1) * this.state.riwayatPagination.pageSize,
        );

        if (resp && resp._warning) {
          this.setState({
            successVisible: true,
            successType: 'warning',
            successTitle: 'Koreksi Berhasil — Ada Peringatan',
            successContent: (
              <div>
                <p>Nomor notice berhasil diperbarui.</p>
                <p style={{ marginBottom: 4 }}>
                  <strong>Perhatian:</strong> Nomor notice{' '}
                  <strong>{values.kode_notice} {values.notice_number}</strong>{' '}
                  sudah digunakan oleh transaksi lain:
                </p>
                <ul style={{ paddingLeft: 16, marginBottom: 0 }}>
                  {resp._warning.nomor_polisi.map((np) => (
                    <li key={np}><strong>{np}</strong></li>
                  ))}
                </ul>
                <p style={{ marginTop: 8, marginBottom: 0, color: '#92400e', fontSize: 12 }}>
                  Baris dengan nomor notice yang sama ditandai merah di tabel.
                </p>
              </div>
            ),
          });
        } else {
          this.setState({
            successVisible: true,
            successType: 'success',
            successTitle: 'Koreksi Berhasil',
            successContent: 'Nomor notice berhasil diperbarui.',
          });
        }
      } else {
        const errTitle = 'gagal menyimpan data';
        message.error({ content: errTitle, duration: 2, key: 'toast' });
        this.setState({ errTitle, errMsg: this.props.responseMsg });
      }
    }).catch(() => {
      this.setState({ loadingSave: false });
      const errTitle = 'gagal menyimpan data';
      message.error({ content: errTitle, duration: 2, key: 'toast' });
      this.setState({ errTitle, errMsg: 'Terjadi kesalahan saat menyimpan.' });
    });
  };

  // ── Koreksi Massal (renumber rentang nomor yang salah counter) ──────
  _extractMassalError = (resp, fallback) => {
    if (resp && typeof resp === 'object' && resp.error) return resp.error;
    if (typeof resp === 'string' && resp) return resp;
    return fallback;
  };

  openMassal = async () => {
    if (this.props.is_superuser && !this.state.selectedUpt) {
      toastError('Pilih UPT terlebih dahulu sebelum koreksi massal');
      return;
    }
    this.setState({ isModalMassal: true, massalPreview: null, massalValues: null });
    // Prefill kode notice dari batas-notice (kode aktif UPT)
    try {
      const batasParams = new URLSearchParams();
      if (this.props.is_superuser && this.state.selectedUpt) batasParams.set('upt', this.state.selectedUpt);
      await this.props.ajaxViewHandler('get',
        `${configClass.apiUrl.data}batas-notice/${batasParams.toString() ? '?' + batasParams.toString() : ''}`);
      if (this.props.isSuccess && this.formMassalRef.current) {
        this.formMassalRef.current.setFieldsValue({
          kode_notice: this.props.responseMsg.kode_notice || '',
        });
      }
    } catch {
      // prefill gagal tidak apa-apa, user isi manual
    }
  };

  handleMassalPeriksa = async () => {
    let values;
    try {
      values = await this.formMassalRef.current.validateFields();
    } catch {
      return;
    }
    const payload = {
      kode_notice: values.kode_notice,
      nomor_dari: parseInt(values.nomor_dari, 10),
      nomor_sampai: parseInt(values.nomor_sampai, 10),
      nomor_baru_mulai: parseInt(values.nomor_baru_mulai, 10),
      keterangan: values.keterangan || '',
      paksa: !!values.paksa,
      preview: true,
    };
    if (this.props.is_superuser && this.state.selectedUpt) payload.upt = this.state.selectedUpt;
    this.setState({ loadingMassalPreview: true });
    this.props.ajaxHandler('post', `${configClass.apiUrl.data}koreksi-massal/`, payload, false, true)
      .then(() => {
        if (this.props.isSuccess) {
          this.setState({ massalPreview: this.props.responseMsg, massalValues: payload });
        } else {
          toastError(this._extractMassalError(this.props.responseMsg, 'Gagal memeriksa rentang'), 5);
        }
        this.setState({ loadingMassalPreview: false });
      }).catch(() => {
        toastError('Gagal memeriksa rentang, coba lagi');
        this.setState({ loadingMassalPreview: false });
      });
  };

  handleMassalKonfirmasi = () => {
    const payload = { ...this.state.massalValues };
    delete payload.preview;
    this.setState({ loadingMassalSubmit: true });
    this.props.ajaxHandler('post', `${configClass.apiUrl.data}koreksi-massal/`, payload, false, true)
      .then(() => {
        this.setState({ loadingMassalSubmit: false });
        if (this.props.isSuccess) {
          const data = this.props.responseMsg || {};
          this.setState({ isModalMassal: false, massalPreview: null, massalValues: null });
          this.getData(this.state.pagination.pageSize, 0);
          this.getRiwayat(this.state.riwayatPagination.pageSize, 0);
          this.setState({
            successVisible: true,
            successType: 'success',
            successTitle: 'Koreksi Massal Berhasil',
            successContent: (
              <div>
                <p><strong>{data.jumlah}</strong> transaksi berhasil dinomori ulang.</p>
                {data.counter_baru !== null && data.counter_baru !== undefined && (
                  <p style={{ marginBottom: data.peringatan_duplikat && data.peringatan_duplikat.length > 0 ? 8 : 0 }}>
                    Counter Pengaturan Notice ikut dibetulkan:{' '}
                    <strong>{data.counter_lama}</strong> → <strong>{data.counter_baru}</strong>.
                  </p>
                )}
                {data.peringatan_duplikat && data.peringatan_duplikat.length > 0 && (
                  <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 8,
                                padding: '8px 12px', marginTop: 4, fontSize: 12.5, color: '#873800' }}>
                    <b>{data.peringatan_duplikat.length} nomor jadi duplikat sementara</b> - perlu dibereskan
                    manual lewat koreksi satu-satu:
                    <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
                      {data.peringatan_duplikat.map((p, i) => (
                        <li key={i}>
                          <b>{data.kode} {p.nomor_tujuan}</b>: {p.nomor_polisi_dikoreksi} vs {p.nomor_polisi_bentrok}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ),
          });
        } else {
          toastError(this._extractMassalError(this.props.responseMsg, 'Gagal menyimpan koreksi massal'), 5);
        }
      }).catch(() => {
        toastError('Gagal menyimpan koreksi massal, coba lagi');
        this.setState({ loadingMassalSubmit: false });
      });
  };

  renderModalMassal = () => {
    const { isModalMassal, massalPreview, loadingMassalPreview, loadingMassalSubmit } = this.state;
    const mappingCols = [
      { title: 'Nomor Polisi', dataIndex: 'nomor_polisi', width: 120,
        render: v => <Text strong style={{ fontSize: 12, color: '#0f2847' }}>{v}</Text> },
      { title: 'Nomor Lama', dataIndex: 'lama', width: 100, align: 'center',
        render: v => <Text delete style={{ fontSize: 12, color: '#a8071a' }}>{v}</Text> },
      { title: '', width: 30, align: 'center', render: () => <ArrowRightOutlined style={{ fontSize: 10, color: '#999' }} /> },
      { title: 'Nomor Baru', dataIndex: 'baru', width: 100, align: 'center',
        render: v => <Text strong style={{ fontSize: 12, color: '#135200' }}>{v}</Text> },
    ];
    return (
      <Modal
        title={<span><SwapOutlined style={{ color: '#0f2847', marginRight: 8 }} />Koreksi Massal Nomor Notice</span>}
        open={isModalMassal}
        onCancel={() => this.setState({ isModalMassal: false, massalPreview: null, massalValues: null })}
        footer={null} destroyOnClose width="min(95vw, 620px)">
        {!massalPreview ? (
          <div>
            <div style={{ background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 8,
                          padding: '8px 14px', marginBottom: 14, fontSize: 12, color: '#614700' }}>
              <ExclamationCircleOutlined style={{ marginRight: 8, color: '#faad14' }} />
              Untuk kasus counter salah ketik dan transaksi <b>terlanjur tercetak</b> dengan
              nomor salah (misal tercatat 1500 padahal kertas fisiknya 1050). Seluruh
              transaksi pada rentang salah dinomori ulang berurutan dan counter ikut
              dibetulkan. Maksimal 100 transaksi per operasi.
            </div>
            <Form ref={this.formMassalRef} layout="vertical" onFinish={this.handleMassalPeriksa}>
              <Row gutter={[12, 0]}>
                <Col xs={12} sm={6}>
                  <Form.Item label="Kode Notice" name="kode_notice"
                             rules={[{ required: true, message: 'Wajib diisi' }]}>
                    <Input style={{ borderRadius: 8, fontWeight: 700, letterSpacing: 1 }} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Item label="Nomor Salah: Dari" name="nomor_dari"
                             rules={[{ required: true, message: 'Wajib diisi' }]}>
                    <Input type="number" min={1} className="no-uppercase" style={{ borderRadius: 8, fontWeight: 700 }} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Item label="Sampai" name="nomor_sampai"
                             rules={[{ required: true, message: 'Wajib diisi' }]}>
                    <Input type="number" min={1} className="no-uppercase" style={{ borderRadius: 8, fontWeight: 700 }} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Item label="Seharusnya Mulai" name="nomor_baru_mulai"
                             rules={[{ required: true, message: 'Wajib diisi' }]}>
                    <Input type="number" min={1} className="no-uppercase" style={{ borderRadius: 8, fontWeight: 700 }} />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item label="Keterangan (opsional)" name="keterangan">
                    <Input className="no-uppercase" placeholder="cth: counter salah ketik 1500, seharusnya 1050"
                           style={{ borderRadius: 8 }} />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item name="paksa" valuePropName="checked" style={{ marginBottom: 0 }}>
                    <Checkbox>
                      <span style={{ fontSize: 12.5 }}>
                        Paksa lanjutkan meski nomor tujuan bentrok dengan transaksi aktif lain
                        (akan jadi <b>duplikat sementara</b>, dibereskan manual lewat koreksi satu-satu)
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={8} justify="end">
                <Col>
                  <Button onClick={() => this.setState({ isModalMassal: false })}
                          style={{ borderRadius: 8 }}>Batal</Button>
                </Col>
                <Col>
                  <Button type="primary" htmlType="submit" icon={<SearchOutlined />}
                          loading={loadingMassalPreview}
                          style={{ borderRadius: 8, fontWeight: 600, background: '#0f2847', borderColor: '#0f2847' }}>
                    Periksa
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        ) : (
          <div>
            <div style={{ background: '#fff2f0', border: '1px solid #ffccc7', borderRadius: 8,
                          padding: '8px 14px', marginBottom: 12, fontSize: 12, color: '#a8071a' }}>
              <WarningOutlined style={{ marginRight: 8 }} />
              <b>{massalPreview.jumlah} transaksi</b> berikut akan dinomori ulang. Periksa
              baris per baris sebelum konfirmasi - perubahan tercatat di Riwayat Koreksi.
            </div>
            <div style={{ overflowX: 'auto', marginBottom: 12 }}>
              <Table rowKey="id" size="small" columns={mappingCols}
                     dataSource={massalPreview.mapping || []}
                     pagination={false} scroll={{ y: 260 }} />
            </div>
            {massalPreview.counter_baru !== null && massalPreview.counter_baru !== undefined && (
              <div style={{ fontSize: 12, color: '#0f2847', marginBottom: 12 }}>
                Counter Pengaturan Notice akan dibetulkan:{' '}
                <b>{massalPreview.counter_lama}</b> → <b>{massalPreview.counter_baru}</b>
              </div>
            )}
            {massalPreview.peringatan_duplikat && massalPreview.peringatan_duplikat.length > 0 && (
              <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 8,
                            padding: '8px 14px', marginBottom: 12, fontSize: 12, color: '#873800' }}>
                <ExclamationCircleOutlined style={{ marginRight: 8, color: '#d46b08' }} />
                <b>Dipaksa lanjut</b> - {massalPreview.peringatan_duplikat.length} nomor berikut akan jadi
                duplikat dengan transaksi aktif lain, perlu dibereskan manual lewat koreksi satu-satu nanti:
                <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
                  {massalPreview.peringatan_duplikat.map((p, i) => (
                    <li key={i}>
                      <b>{massalPreview.kode} {p.nomor_tujuan}</b>: {p.nomor_polisi_dikoreksi} vs {p.nomor_polisi_bentrok}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <Row gutter={8} justify="end">
              <Col>
                <Button onClick={() => this.setState({ massalPreview: null })}
                        style={{ borderRadius: 8 }} disabled={loadingMassalSubmit}>
                  Kembali
                </Button>
              </Col>
              <Col>
                <Button type="primary" danger icon={<SwapOutlined />}
                        loading={loadingMassalSubmit} onClick={this.handleMassalKonfirmasi}
                        style={{ borderRadius: 8, fontWeight: 600 }}>
                  Ya, Nomori Ulang {massalPreview.jumlah} Transaksi
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </Modal>
    );
  };

  // Sisipkan baris penanda "loncat nomor" tepat sebelum baris data yang
  // punya gap_before, tanpa mengganggu nomor urut (No) baris data asli.
  _buildTableRows = (dataSource) => {
    const rows = [];
    dataSource.forEach((row, i) => {
      if (row.gap_before) {
        rows.push({ __isGapRow: true, key: `gap-${row.id}`, gap_before: row.gap_before });
      }
      rows.push({ ...row, _rowNumber: i + 1 });
    });
    return rows;
  };

  _fmtNoticeRange(kode, dari, sampai) {
    const k = kode ? `${kode} ` : '';
    return dari === sampai ? `${k}${dari}` : `${k}${dari} – ${k}${sampai}`;
  }

  _renderGapBanner(gap) {
    const range = this._fmtNoticeRange(gap.kode_notice, gap.dari, gap.sampai);
    if (gap.status === 'rusak_confirmed') {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px', background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6 }}>
          <CheckCircleOutlined style={{ color: '#389e0d' }} />
          <Text style={{ fontSize: 12.5 }}>
            Loncat {gap.jumlah} nomor: <strong>{range}</strong> — sudah tercatat <Text strong style={{ color: '#389e0d' }}>RUSAK</Text>
          </Text>
        </div>
      );
    }
    if (gap.status === 'sebagian') {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px', background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 6 }}>
          <ExclamationCircleOutlined style={{ color: '#d48806' }} />
          <Text style={{ fontSize: 12.5 }}>
            Loncat {gap.jumlah} nomor: <strong>{range}</strong> — sebagian sudah tercatat rusak
            {gap.nomor_rusak_ketemu && gap.nomor_rusak_ketemu.length > 0 && (
              <> ({gap.kode_notice ? gap.kode_notice + ' ' : ''}{gap.nomor_rusak_ketemu.join(', ')})</>
            )}
            , sisanya <Text strong style={{ color: '#d48806' }}>belum ada catatan — cek manual</Text>
          </Text>
        </div>
      );
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 12px', background: '#fff2e8', border: '1px solid #ffbb96', borderRadius: 6 }}>
        <WarningOutlined style={{ color: '#d4380d' }} />
        <Text style={{ fontSize: 12.5 }}>
          Loncat {gap.jumlah} nomor: <strong>{range}</strong> — <Text strong style={{ color: '#d4380d' }}>BELUM ada catatan rusak, cek manual</Text>
        </Text>
      </div>
    );
  }

  _renderRingkasanLoncatan() {
    const r = this.state.ringkasanLoncatan;
    if (!r || r.total_loncatan === 0) return null;
    const perluCek = r.perlu_cek > 0;
    return (
      <Alert
        style={{ marginBottom: 12, borderRadius: 8 }}
        type={perluCek ? 'warning' : 'success'}
        showIcon
        message={
          `Ditemukan ${r.total_loncatan} loncatan nomor notice hari ini — `
          + `${r.sudah_rusak} sudah terkonfirmasi rusak`
          + (perluCek ? `, ${r.perlu_cek} perlu dicek manual` : '')
        }
      />
    );
  }

  // Jumlah kolom di `columns` - dipakai colSpan baris gap supaya full-width.
  static TOTAL_KOLOM_TRANSAKSI = 7;

  columns = [
    {
      title: 'No',
      width: 50,
      align: 'center',
      render: (_, record) => {
        if (record.__isGapRow) {
          return { children: this._renderGapBanner(record.gap_before), props: { colSpan: DataKoreksiNomorNotice.TOTAL_KOLOM_TRANSAKSI } };
        }
        const { pagination } = this.state;
        return (pagination.current - 1) * pagination.pageSize + record._rowNumber;
      },
    },
    {
      title: 'Nomor Polisi',
      dataIndex: 'nomor_polisi',
      key: 'nomor_polisi',
      width: 150,
      render: (v, record) => {
        if (record.__isGapRow) return { children: null, props: { colSpan: 0 } };
        return (
          <data style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, whiteSpace: 'nowrap', color: '#0f2847' }}>
            <Text strong>{v}</Text>
          </data>
        );
      },
    },
    {
      title: 'Nama WP',
      dataIndex: 'nama_wp',
      key: 'nama_wp',
      render: (v, record) => {
        if (record.__isGapRow) return { children: null, props: { colSpan: 0 } };
        return (
          <Text strong>{v}</Text>
        );
      },
    },
    {
      title: 'Tgl Penetapan',
      dataIndex: 'tgl_penetapan_fmt',
      key: 'tgl_penetapan_fmt',
      width: 200,
      render: (v, record) => {
          if (record.__isGapRow) return { children: null, props: { colSpan: 0 } };
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, whiteSpace: 'nowrap' }}>
            {v}
            </div>
          );
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 300,
      render: (v, record) => {
        if (record.__isGapRow) return { children: null, props: { colSpan: 0 } };
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, whiteSpace: 'nowrap' }}>
            <Tag color={STATUS_COLOR[v] || 'default'} style={{ marginRight: 0 }}>{STATUS_LABEL[v] || '-'}</Tag>
            {v === 3 && record.paid_on && (
              <Text strong style={{ fontSize: 11, color: '#0f2847' }}>
                {moment(record.paid_on).format('DD-MM-YYYY HH:mm')}
              </Text>
            )}
          </div>
        );
      },
    },
    {
      title: 'Nomor Notice',
      dataIndex: 'notice_number',
      key: 'notice_number',
      align: 'center',
      width: 150,
      render: (v, row) => {
        if (row.__isGapRow) return { children: null, props: { colSpan: 0 } };
        return (
          <div style={{ lineHeight: 1.4 }}>
            <Text strong>{row.kode_notice ? `${row.kode_notice} ${v}` : v || '-'}</Text>
            {row.is_notice_duplikat && (
              <div style={{ fontSize: 11, color: '#cf1322', marginTop: 2 }}>
                ⚠ Notice ini dipakai lebih dari 1 transaksi
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: 'Aksi',
      key: 'aksi',
      align: 'center',
      width: 80,
      render: (_, record) => {
        if (record.__isGapRow) return { children: null, props: { colSpan: 0 } };
        return (
          <Tooltip title="Edit Nomor Notice">
            <Button
              type="primary"
              size="small"
              icon={<EditOutlined />}
              onClick={() => this.openEdit(record)}
              style={{ borderRadius: 6, background: '#1e4d8a', borderColor: '#1e4d8a' }}
            />
          </Tooltip>
        );
      },
    },
  ];

  riwayatColumns = [
    {
      title: 'No',
      width: 50,
      align: 'center',
      render: (_, __, idx) => {
        const { riwayatPagination } = this.state;
        return (riwayatPagination.current - 1) * riwayatPagination.pageSize + idx + 1;
      },
    },
    {
      title: 'Waktu Koreksi',
      dataIndex: 'created_at_fmt',
      key: 'created_at_fmt',
      width: 140,
    },
    {
      title: 'Nomor Polisi',
      dataIndex: 'nomor_polisi',
      key: 'nomor_polisi',
      render: (v) => <Text strong>{v}</Text>,
    },
    {
      title: 'Notice Lama',
      key: 'notice_lama',
      align: 'center',
      render: (_, row) => (
        <Text type="secondary">
          {row.kode_notice_lama ? `${row.kode_notice_lama} ` : ''}{row.notice_number_lama}
        </Text>
      ),
    },
    {
      title: '',
      key: 'arrow',
      width: 30,
      align: 'center',
      render: () => <Text type="secondary">→</Text>,
    },
    {
      title: 'Notice Baru',
      key: 'notice_baru',
      align: 'center',
      render: (_, row) => (
        <Text strong style={{ color: '#1e4d8a' }}>
          {row.kode_notice_baru ? `${row.kode_notice_baru} ` : ''}{row.notice_number_baru}
        </Text>
      ),
    },
    {
      title: 'Dikoreksi Oleh',
      dataIndex: 'nama_pegawai',
      key: 'nama_pegawai',
    },
  ];

  render() {
    const {
      activeTab,
      kabupatenList, uptList, selectedKabupaten, selectedUpt, loadingKabupaten, loadingUpt,
      loadingData, dataSource, pagination, searchText, tanggal,
      loadingRiwayat, riwayatSource, riwayatPagination,
      isModalEdit, loadingSave, editRecord, loadingBatas, batasNotice,
      errTitle, errMsg,
      successVisible, successType, successTitle, successContent,
    } = this.state;

    // +1 - backend (KoreksiNomorNoticeViewset.partial_update) mengizinkan
    // nomor PERSIS counter+1 (nomor berikutnya yang belum pernah
    // diterbitkan, gap=0) - lihat diskusi 2026-10-02. Tetap dibatasi
    // nomor_akhir box aktif, jadi validasi FE ini cuma preview/UX,
    // backend yang jadi penentu akhir.
    const maxNotice = batasNotice
      ? Math.min(
          (batasNotice.penggunaan_terakhir ?? Infinity) + 1,
          batasNotice.nomor_akhir ?? Infinity,
        )
      : null;
    // minNotice (batas bawah = nomor_awal box AKTIF saat ini) DIHAPUS -
    // backend sekarang menerima nomor dari box mana pun yang pernah dipakai
    // (aktif ATAU habis, lihat _nomor_pernah_dipakai_box), tidak cuma box
    // aktif sekarang. Validasi batas bawah di sini jadi usang dan salah
    // menolak koreksi ke box lama yang sudah habis (lihat diskusi 2026-10-06).
    // Backend tetap jadi penentu akhir - nomor yang benar-benar tidak sah
    // (bukan dari box aktif/habis mana pun) akan ditolak lewat ErrorAlertModal
    // seperti validasi backend-only lain (mis. "sudah tercatat rusak").

    return (
      <div>
        <Helmet>
          <title>{configClass.title} | eSamsat</title>
          <style>{`
            .header-koreksi-notice {
              background: linear-gradient(135deg, #0f2847 0%, #1e4d8a 100%);
              border-radius: 12px 12px 0 0;
              padding: 20px 24px;
            }
            .row-duplikat-notice td {
              background-color: #fff1f0 !important;
            }
            .row-duplikat-notice:hover td {
              background-color: #ffccc7 !important;
            }
          `}</style>
        </Helmet>


        <Card
          bodyStyle={{ padding: 0 }}
          style={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}
        >
          {/* Header */}
          <div className="header-koreksi-notice">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 12, marginBottom: 2 }}>
                  Transaksi Terbayar
                </div>
                <div style={{ color: '#fff', fontWeight: 700, fontSize: 18, letterSpacing: 0.5 }}>
                  <FileTextOutlined style={{ marginRight: 8 }} />
                  Koreksi Nomor Notice
                </div>
              </div>
            </div>
          </div>

          {/* Filter Bar */}
          <div style={{ padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fafafa' }}>
            <Row gutter={[8, 8]} align="middle">
              <Col style={{ minWidth: 180 }}>
                <Select
                  placeholder="Pilih Kabupaten"
                  allowClear
                  loading={loadingKabupaten}
                  disabled={this.isKabupatenLocked()}
                  style={{ width: '100%', borderRadius: 8 }}
                  value={selectedKabupaten}
                  onChange={this.handleKabupatenChange}
                  onClear={() => this.setState({ selectedKabupaten: null, selectedUpt: null, uptList: [] }, () => {
                    this.getData(this.state.pagination.pageSize, 0);
                    this.getRiwayat(this.state.riwayatPagination.pageSize, 0);
                  })}
                >
                  {kabupatenList.map(k => (
                    <Select.Option key={k.id} value={k.id}>{k.name}</Select.Option>
                  ))}
                </Select>
              </Col>
              <Col style={{ minWidth: 180 }}>
                <Select
                  placeholder="Pilih UPT"
                  allowClear
                  loading={loadingUpt}
                  disabled={!selectedKabupaten}
                  style={{ width: '100%', borderRadius: 8 }}
                  value={selectedUpt}
                  onChange={this.handleUptChange}
                  onClear={() => this.setState({ selectedUpt: null }, () => {
                    this.getData(this.state.pagination.pageSize, 0);
                    this.getRiwayat(this.state.riwayatPagination.pageSize, 0);
                  })}
                >
                  {uptList.map(u => (
                    <Select.Option key={u.id} value={u.id}>{u.nama}</Select.Option>
                  ))}
                </Select>
              </Col>
              <Col>
                <DatePicker
                  value={tanggal}
                  onChange={this.handleTanggalChange}
                  format="DD-MM-YYYY"
                  allowClear={false}
                  style={{ borderRadius: 8 }}
                />
              </Col>
              {activeTab === 'transaksi' && (
                <>
                  <Col flex="1" style={{ minWidth: 160, maxWidth: 260 }}>
                    <Input
                      placeholder="Cari nomor polisi..."
                      value={searchText}
                      onChange={(e) => this.setState({ searchText: e.target.value })}
                      onPressEnter={this.handleSearch}
                      prefix={<SearchOutlined style={{ color: '#aaa' }} />}
                      style={{ borderRadius: 8 }}
                    />
                  </Col>
                  <Col>
                    <Button
                      icon={<SearchOutlined />}
                      onClick={this.handleSearch}
                      type="primary"
                      style={{ borderRadius: 8, background: '#1e4d8a', borderColor: '#1e4d8a' }}
                    >
                      Cari
                    </Button>
                  </Col>
                </>
              )}
              <Col>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={() => {
                    const today = moment();
                    this.setState({
                      searchText: '', tanggal: today,
                      pagination: { ...pagination, current: 1 },
                      riwayatPagination: { ...riwayatPagination, current: 1 },
                    }, () => {
                      this.getData(undefined, 0, '', today);
                      this.getRiwayat(undefined, 0, today);
                    });
                  }}
                  style={{ borderRadius: 8 }}
                >
                  Reset
                </Button>
              </Col>
              <Col>
                <Tooltip title="Nomori ulang serentak transaksi yang terlanjur tercetak dengan nomor salah">
                  <Button
                    icon={<SwapOutlined />}
                    onClick={this.openMassal}
                    style={{ borderRadius: 8, borderColor: '#0f2847', color: '#0f2847', fontWeight: 600 }}
                  >
                    Koreksi Massal
                  </Button>
                </Tooltip>
              </Col>
            </Row>
          </div>

          {/* Tabs */}
          <div style={{ padding: '0 20px' }}>
            <Tabs
              activeKey={activeTab}
              onChange={this.handleTabChange}
              style={{ marginTop: 4 }}
            >
              <TabPane
                tab={<span><FileTextOutlined /> Transaksi</span>}
                key="transaksi"
              >
                {this._renderRingkasanLoncatan()}
                <Table
                  rowKey={(record) => (record.__isGapRow ? record.key : record.id)}
                  columns={this.columns}
                  dataSource={this._buildTableRows(dataSource)}
                  loading={loadingData}
                  pagination={false}
                  rowClassName={(record) => record.is_notice_duplikat ? 'row-duplikat-notice' : ''}
                  size="small"
                  bordered
                  scroll={{ x: 800 }}
                  style={{ marginBottom: 16 }}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Pagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    showSizeChanger
                    pageSizeOptions={['10', '25', '50', '100']}
                    showTotal={(total) => `Total ${total} transaksi`}
                    onChange={this.handlePaginationChange}
                    onShowSizeChange={this.handlePaginationChange}
                  />
                </div>
              </TabPane>
              <TabPane
                tab={<span><HistoryOutlined /> Riwayat Koreksi</span>}
                key="riwayat"
              >
                <Table
                  rowKey="id"
                  columns={this.riwayatColumns}
                  dataSource={riwayatSource}
                  loading={loadingRiwayat}
                  pagination={{
                    ...riwayatPagination,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '25', '50', '100'],
                    showTotal: (total) => `Total ${total} koreksi`,
                  }}
                  onChange={this.handleRiwayatTableChange}
                  size="small"
                  bordered
                  scroll={{ x: 700 }}
                  style={{ marginBottom: 16 }}
                />
              </TabPane>
            </Tabs>
          </div>
        </Card>

        {/* Modal Edit */}
        <Modal
          title={
            <div style={{ fontWeight: 700, color: '#0f2847' }}>
              <EditOutlined style={{ marginRight: 8 }} />
              Edit Nomor Notice
            </div>
          }
          visible={isModalEdit}
          onCancel={() => this.setState({ isModalEdit: false, editRecord: null })}
          footer={[
            <Button
              key="batal"
              onClick={() => this.setState({ isModalEdit: false, editRecord: null })}
            >
              Batal
            </Button>,
            <Button
              key="simpan"
              type="primary"
              icon={<CheckCircleOutlined />}
              loading={loadingSave}
              onClick={this.handleSave}
              style={{ background: '#1e4d8a', borderColor: '#1e4d8a', borderRadius: 8, fontWeight: 600 }}
            >
              Simpan
            </Button>,
          ]}
          destroyOnClose
          centered
        >
          {editRecord && (
            <div style={{ marginBottom: 12, background: '#f8fafc', borderRadius: 8, padding: '12px 14px' }}>
              <Row gutter={[12, 8]}>
                <Col span={12}>
                  <Text type="secondary" style={{ fontSize: 11 }}>Nomor Polisi</Text>
                  <div><Text strong>{editRecord.nomor_polisi}</Text></div>
                </Col>
                <Col span={12}>
                  <Text type="secondary" style={{ fontSize: 11 }}>Kode Notice Saat Ini</Text>
                  <div><Text strong>{editRecord.kode_notice || '-'}</Text></div>
                </Col>
                <Col span={12}>
                  <Text type="secondary" style={{ fontSize: 11 }}>Nomor Notice Saat Ini</Text>
                  <div><Text strong style={{ fontSize: 15, color: '#1e4d8a' }}>{editRecord.notice_number || '-'}</Text></div>
                </Col>
                {/* Info batas notice */}
                {loadingBatas ? (
                  <div style={{ textAlign: 'center', padding: '8px 0', marginBottom: 12 }}>
                    <Text type="secondary" style={{ fontSize: 12 }}>Memuat batas notice...</Text>
                  </div>
                ) : batasNotice ? (
                  <Col span={12}>
                    <div style={{ marginBottom: 12, background: '#d9f7e0', border: '1px solid #4bdb6f', borderRadius: 8, padding: '10px 14px'}}>
                      <Text type="secondary" style={{ fontSize: 11 }}>Penggunaan Terakhir</Text>
                      <div><Text strong style={{ color: '#1e4d8a' }}>{batasNotice.penggunaan_terakhir ?? '-'}</Text></div>
                    </div>
                  </Col>
                ) : null}
              </Row>
            </div>
          )}

          <Form
            ref={this.formRef}
            layout="vertical"
            key={editRecord ? editRecord.id : 'edit'}
            initialValues={editRecord ? {
              kode_notice: editRecord.kode_notice || '',
            } : {}}
          >
            <Form.Item
              label="Kode Notice Baru"
              name="kode_notice"
              rules={[{ required: true, message: 'Kode notice wajib diisi' }]}
            >
              <Input
                style={{ borderRadius: 8 }}
                placeholder="Kode notice"
                maxLength={50}
                onBlur={this.handleKodeNoticeBlur}
              />
            </Form.Item>
            <Form.Item
              label="Nomor Notice Baru"
              name="notice_number"
              rules={[
                { required: true, message: 'Nomor notice wajib diisi' },
                { pattern: /^\d+$/, message: 'Hanya boleh berisi angka' },
                {
                  validator: (_, value) => {
                    if (!value || !batasNotice) return Promise.resolve();
                    const num = parseInt(value, 10);
                    if (isNaN(num)) return Promise.resolve();
                    if (maxNotice !== null && maxNotice !== Infinity && num > maxNotice) {
                      return Promise.reject(`Nomor notice tidak boleh melebihi ${maxNotice}`);
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                style={{ borderRadius: 8 }}
                placeholder={maxNotice ? `Maks. ${maxNotice}` : 'Masukkan nomor notice'}
                maxLength={20}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, '');
                  this.formRef.current.setFieldsValue({ notice_number: val });
                }}
              />
            </Form.Item>
          </Form>
        </Modal>

        {this.renderModalMassal()}

        <ErrorAlertModal
          visible={errMsg !== ''}
          title={errTitle}
          error={errMsg}
          onClose={() => this.setState({ errTitle: '', errMsg: '' })}
        />

        <SuccessAlertModal
          visible={successVisible}
          type={successType}
          title={successTitle}
          content={successContent}
          okText={successType === 'warning' ? 'Mengerti' : 'OK'}
          onClose={() => this.setState({ successVisible: false })}
        />
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return state.configReducers;
};

export default connect(mapStateToProps, {
  initHandler, setConfig, ajaxViewHandler, ajaxHandler,
})(DataKoreksiNomorNotice);
